import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import {Observable} from 'rxjs';
import {PolicyDTO} from '../models/PolicyDTO';
import {PagedResponseDTO} from '../../common/models/PagedResponseDTO';
import {PagedRequestDTO} from '../../common/models/PagedRequestDTO';

@Injectable({
  providedIn: 'root'
})
export class PolicyService {
  private url = environment.baseUrl + '/policy';

  constructor(private httpClient: HttpClient) {
  }

  getListOfPolicies(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<PolicyDTO>> {
    return this.httpClient.post<PagedResponseDTO<PolicyDTO>>(this.url + '/filter', pagedRequestDTO);
  }

  getInsuredPersonLinkedPolicies(insuredPersonId: number, productId?: number, processingClassId?: number): Observable<PolicyDTO[]> {
    let params = new HttpParams();

    if (productId != null) {
      params = params.set('insuredPersonId', String(insuredPersonId));
      params = params.set('productId', String(productId));
    }
    else if (processingClassId != null) {
      params = params.set('insuredPersonId', String(insuredPersonId));
      params = params.set('processingClassId', String(processingClassId));
    }
    else {
      params = params.set('insuredPersonId', String(insuredPersonId));
    }

    return this.httpClient.get<PolicyDTO[]>(this.url, {params});
  }

  getPolicy(providerId: number): Observable<PolicyDTO> {
    return this.httpClient.get<PolicyDTO>(this.url + '/' + providerId);
  }

  getPolicyBy(personId: number, processingClassID: number): Observable<PolicyDTO> {
    return this.httpClient.get<PolicyDTO>(`${this.url}/byPersonId?personId=${personId}&classId=${processingClassID}`);
  }

  deletePolicy(id: number) {
    return this.httpClient.delete<{}>(this.url + '/' + id);
  }
}
